/**
 * @see https://floating-ui.com/docs/tutorial#arrow-middleware
 */
export const floatingSideToArrowSide = {
    top: 'bottom',
    right: 'left',
    bottom: 'top',
    left: 'right',
};
//# sourceMappingURL=constants.js.map